interface TravelWebhookPayload {
    travelId: string;
    title: string;
    start: string;
    end: string;
    tripPurpose: string;
    userName: string;
    userEmail: string;
    isInternational: boolean;
    destination: string;
    transportationType?: string;
    estimatedCost?: number;
    address?: string;
    isGroup: boolean;
    collaboratorsCount?: number;
    supervisorEmail?: string; 
}

const formatForN8n = (isoDate: string): string => {
    const date = new Date(isoDate);


    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export const sendTravelToN8n = async (
    travelId: string,
    title: string,
    startDateTime: string,
    endDateTime: string,
    tripPurpose: string,
    userName: string,
    userEmail: string,
    isInternational: boolean,
    destination: string,
    transportationType?: string,
    estimatedCost?: number,
    address?: string,
    isGroup?: boolean,
    collaboratorsCount?: number,
    supervisorEmail?: string,


): Promise<{ success: boolean; error?: string }> => {
    const N8N_WEBHOOK_URL = import.meta.env.VITE_N8N_WEBHOOK_CREATE_TRAVEL_EMAIL_URL;

    if (!N8N_WEBHOOK_URL) {
        return { success: false, error: 'Webhook URL no configurada' };
    }

    try {
        const payload: TravelWebhookPayload = {
            travelId,
            title,
            start: formatForN8n(startDateTime),
            end: formatForN8n(endDateTime),
            tripPurpose,
            userName,
            userEmail,
            isInternational,
            destination,
            transportationType,
            estimatedCost,
            address,
            isGroup: isGroup || false,
            collaboratorsCount,
            supervisorEmail
        };

        const response = await fetch(N8N_WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            // const errorText = await response.text();
            // console.error(' Error n8n:', response.status, errorText);
            return { success: false, error: `HTTP ${response.status}` };
        }

        return { success: true };

    } catch (error) {
        console.error('Error enviando a n8n:', error);
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Error desconocido'
        };
    }
};

